import { render, staticRenderFns } from "./taxPayerSystem.vue?vue&type=template&id=295774a2&scoped=true&"
import script from "./taxPayerSystem.vue?vue&type=script&lang=js&"
export * from "./taxPayerSystem.vue?vue&type=script&lang=js&"
import style0 from "./taxPayerSystem.vue?vue&type=style&index=0&id=295774a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295774a2",
  null
  
)

export default component.exports